<template>
  <el-container style="height: 100%">
    <el-header style="display: flex;justify-content: space-between;align-items: center">
      <h1 style="width: 85%">河南省交通运输科学技术进步奖申报系统</h1>
      <!--      <el-tooltip effect="dark" content="操作文档" placement="bottom" style="float: right;"></el-tooltip>-->
      <div style="display: flex;cursor: pointer;"  @click="onPreviewGuide()">
        <img src="../assets/guide.png" style="width: 1vw;vertical-align: top">
        <div style="color: #1a89ff;font-weight: bolder;margin-right: 10px">操作指南</div>
      </div>
      <el-dropdown size="medium" placement="bottom" style="cursor: pointer;margin-right:3.6vw;margin-top:1vh;">
        <img src='../assets/avator.png' style="width: 1.5vw;height: 3vh">
        <el-dropdown-menu
          slot="dropdown"
          style="width: 9.1vw;">
          <div style="text-align:center; color: #000000;font-size:0.8vw;width: 7.5vw;margin-left: 0.8vw;margin-top:1vh">{{ username }}</div>
          <div style="width:7.5vw;height:1px;border-top:solid rgb(180,180,180) 1px;margin-left: 0.8vw;margin-top:1vh"></div>
          <div>
            <img src="../assets/userChangePassword.png" style="width:0.7vw;height:1.5vh;margin-top: 1.5vh;margin-left: 2.2vw">
            <span style="font-size:0.8vw;font-weight:500;color: #000000;cursor: pointer;position:absolute; margin-top: 1.2vh; margin-left: 0.3vw" @click="changePassWord">修改密码</span>
          </div>
          <div style="width:7.5vw;height:1px;border-top:solid rgb(180,180,180) 1px;margin-left: 0.8vw;margin-top:1vh"></div>
          <div>
            <img src="../assets/logout.png" style="width:0.7vw;height:1.5vh;margin-top: 1.5vh;margin-left: 2.2vw;margin-bottom:0.5vh">
            <span style="font-size:0.8vw;font-weight:500;color: #000000;cursor: pointer;position:absolute; margin-top: 1.2vh; margin-left: 0.3vw" @click="logout">退出登录</span>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>
    <el-main style="height: 98%;padding: 0">
      <router-view></router-view>
    </el-main>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="旧密码">
          <el-input v-model="form.oldPwd" placeholder="请输入旧密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="form.newPwd" placeholder="请输入新密码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="changePassWordSubmit">确 定</el-button>
  </span>
    </el-dialog>
  </el-container>
</template>

<script>
import utils from "./js/utils";

export default {
  name: "HomePage",
  data() {
    return {
      username: '',
      isRemember: null,
      dialogVisible: false,
      form: {
        oldPwd: '',
        newPwd: '',
      },
      rules: {
        oldPwd: {required: true, message: ' ', trigger: 'blur'},
        newPwd: {required: true, message: ' ', trigger: 'blur'},
      },

    }
  },
  methods: {
    onPreviewGuide() {
      let guideURL = this.GLOBAL.EXPORTURL + 'pingjiang/file/河南省交通运输科学技术进步奖填报指南.pdf'
      window.open(guideURL, "_blank");
    },
    changePassWord() {
      this.dialogVisible = true
    },
    changePassWordSubmit() {
      this.$refs.form.validate(val => {
        if (val) {
          this.$axios({
            method: 'post',
            url: this.GLOBAL.URL + 'user/updateUserPassword',
            data: {
              oldPwd: utils.encrypt(this.form.oldPwd, 'sheyanyuan888@ab'),
              newPwd: utils.encrypt(this.form.newPwd, 'sheyanyuan888@ab'),
              userid: sessionStorage.getItem('userid')
            }
          }).then(res => {
            let resp = JSON.parse(utils.decrypt(res.data, 'sheyanyuan888@ab'));
            if (resp.code == 1000) {
              this.showSuccessMsg("请重新登录")
              this.handleClose()
              this.clearCookie();
              sessionStorage.setItem("token", ' ');
              this.$router.push({
                path: '/'
              })
            } else {
              this.showFailMsg(resp.message)
            }
          })
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
      Object.assign(this.form, this.$options.data().form)
    },
    logout() {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.isRemember = this.docCookies.getItem('isRemember')
        if (this.isRemember == 'false' || this.isRemember == null) {
          this.clearCookie();
          sessionStorage.setItem("token", ' ');
        }
        this.$router.push({
          path: '/'
        })
      }).catch(() => {

      });
    },
    //清空cookie除了勾选记住用户名密码
    clearCookie() {
      this.docCookies.removeItem('real_loginname')
      this.docCookies.removeItem('real_password')
      this.docCookies.removeItem('isRemember')
    },
  },
  created() {
    this.username = sessionStorage.getItem('username')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/HomePage.vue